import { StyleSheet } from 'react-native';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const style = StyleSheet.create({
  titleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  title: {
    ...textLatoStyleDS.TitleBoldXl,
  },
  description: {
    ...textLatoStyleDS.BodyRegularMd,
  },
  videoContainer: {
    height: 288,
  },
});
